<template>
<div class="chapter">
<div class="inner_page">
<h1 class="BookTitle">The Lincoln Lawyer</h1>
<h2 class="BookSubtitle" style="margin-top:60px;">A Mysterious Profile</h2>
<p class="author" style="margin-top:60px;">Michael Connelly</p>
<p class="center" style="margin-top:80px;"><img alt="image" src="image/logo3.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// LincolnLawyer-1.vue?481251db